<div class="dashboard-container">
    
    <h1 nz-typography class="mb-4">Dashboard Overview</h1>

    <div nz-row [nzGutter]="[24, 24]" class="mt-4">
        
        <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="6">
            <nz-card [nzBordered]="false" class="stat-card hover-lift" [nzLoading]="loading">
                <nz-statistic 
                    [nzValue]="dashboard?.productActiveCount" 
                    [nzTitle]="'Active Products'"
                    [nzPrefix]="prefixProduct">
                </nz-statistic>
                <ng-template #prefixProduct>
                    <span nz-icon nzType="tablet" class="text-purple me-2"></span>
                </ng-template>
                <div class="sub-text mt-2 border-top pt-2">
                    Total: <strong>{{ dashboard?.productCount }}</strong>
                </div>
            </nz-card>
        </div>

        <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="6">
            <nz-card [nzBordered]="false" class="stat-card hover-lift" [nzLoading]="loading">
                <nz-statistic 
                    [nzValue]="dashboard?.sdkActiveCount" 
                    [nzTitle]="'Active SDKs'"
                    [nzPrefix]="prefixSdk">
                </nz-statistic>
                <ng-template #prefixSdk>
                    <span nz-icon nzType="code" class="text-orange me-2"></span>
                </ng-template>
                <div class="sub-text mt-2 border-top pt-2">
                    Total: <strong>{{ dashboard?.sdkCount }}</strong>
                </div>
            </nz-card>
        </div>

        <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="6">
            <nz-card [nzBordered]="false" class="stat-card hover-lift" [nzLoading]="loading">
                <nz-statistic 
                    [nzValue]="dashboard?.productPackageActiveCount" 
                    [nzTitle]="'Active Packages'"
                    [nzPrefix]="prefixPackage">
                </nz-statistic>
                <ng-template #prefixPackage>
                    <span nz-icon nzType="product" class="text-cyan me-2"></span>
                </ng-template>
                <div class="sub-text mt-2 border-top pt-2">
                    Total: <strong>{{ dashboard?.productPackageCount }}</strong>
                </div>
            </nz-card>
        </div>

        <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="6">
            <nz-card [nzBordered]="false" class="stat-card hover-lift" [nzLoading]="loading">
                <nz-statistic 
                    [nzValue]="dashboard?.driveFileCount" 
                    [nzTitle]="'Google Drive Files'"
                    [nzPrefix]="prefixDriveFiles">
                </nz-statistic>
                <ng-template #prefixDriveFiles>
                    <span nz-icon nzType="google" class="text-google me-2"></span>
                </ng-template>
                <div class="sub-text mt-2 border-top pt-2">
                    Total: <strong>{{ dashboard?.driveFileCount }}</strong>
                </div>
            </nz-card>
        </div>
    </div>

    <!-- <div nz-row [nzGutter]="[24, 24]" class="mt-4">
        
        <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="6">
            <nz-card [nzBordered]="false" class="stat-card hover-lift" [nzLoading]="loading">
                <nz-statistic 
                    [nzValue]="dashboard?.customerActiveCount" 
                    [nzTitle]="'Active Customers'"
                    [nzPrefix]="prefixCustomer">
                </nz-statistic>
                <ng-template #prefixCustomer>
                    <span nz-icon nzType="team" class="text-purple me-2"></span>
                </ng-template>
                <div class="sub-text mt-2 border-top pt-2">
                    Total Registered: <strong>{{ dashboard?.customerCount }}</strong>
                </div>
            </nz-card>
        </div>

        <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="6">
            <nz-card [nzBordered]="false" class="stat-card hover-lift" [nzLoading]="loading">
                <nz-statistic 
                    [nzValue]="dashboard?.organisationActiveCount" 
                    [nzTitle]="'Organisations'"
                    [nzPrefix]="prefixOrg">
                </nz-statistic>
                <ng-template #prefixOrg>
                    <span nz-icon nzType="bank" class="text-orange me-2"></span>
                </ng-template>
                <div class="sub-text mt-2 border-top pt-2">
                    Total Registered: <strong>{{ dashboard?.organisationCount }}</strong>
                </div>
            </nz-card>
        </div>

        <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="6">
            <nz-card [nzBordered]="false" class="stat-card hover-lift" [nzLoading]="loading">
                <nz-statistic 
                    [nzValue]="dashboard?.locationActiveCount" 
                    [nzTitle]="'Locations'"
                    [nzPrefix]="prefixLoc">
                </nz-statistic>
                <ng-template #prefixLoc>
                    <span nz-icon nzType="environment" class="text-cyan me-2"></span>
                </ng-template>
                <div class="sub-text mt-2 border-top pt-2">
                    Total Registered: <strong>{{ dashboard?.locationCount }}</strong>
                </div>
            </nz-card>
        </div>

        <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="6">
            <nz-card [nzBordered]="false" class="stat-card hover-lift" [nzLoading]="loading">
                <nz-statistic 
                    [nzValue]="dashboard?.subLocationActiveCount" 
                    [nzTitle]="'Sub Locations'"
                    [nzPrefix]="prefixSub">
                </nz-statistic>
                <ng-template #prefixSub>
                    <span nz-icon nzType="aim" class="text-red me-2"></span>
                </ng-template>
                <div class="sub-text mt-2 border-top pt-2">
                    Total Registered: <strong>{{ dashboard?.subLocationCount }}</strong>
                </div>
            </nz-card>
        </div>

    </div>
    <div nz-row [nzGutter]="[24, 24]" class="mt-4">
        
        <div nz-col [nzXs]="24" [nzMd]="8">
            <nz-card [nzBordered]="false" class="stat-card" [nzLoading]="loading">
                <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="icon-wrapper bg-purple-light">
                        <span nz-icon nzType="form" nzTheme="outline" class="text-purple"></span>
                    </div>
                    <nz-tag [nzColor]="'purple'">Submissions</nz-tag>
                </div>
                <div nz-row [nzGutter]="[24, 24]">
                    <div nz-col [nzXs]="24" [nzMd]="8" class="mt-4 pt-2">
                        <div>
                            <div class="mini-stat mb-4">
                                <span class="label">Today</span>
                                <span class="value" style="font-size: 28px;">{{ dashboard?.submissionsCountToday || 0 }}</span>
                            </div>
                            <div class="mini-stat">
                                <span class="label">7 Days</span>
                                <span class="value" style="font-size: 28px;">{{ dashboard?.submissionsCount7Days || 0 }}</span>
                            </div>
                        </div>
                    </div>
                    <div nz-col [nzXs]="24" [nzMd]="8" class="mt-4 pt-2">
                        <div>
                            <div class="mini-stat mb-4 align-items-center">
                                <span class="label">Current Month</span>
                                <span class="value" style="font-size: 28px;">{{ dashboard?.submissionsCountMonth || 0 }}</span>
                            </div>
                            
                        </div>
                    </div>
                </div>
                
            </nz-card>
        </div>

        <div nz-col [nzXs]="24" [nzMd]="16">
            <nz-card nzTitle="Submissions by Category" [nzBordered]="false" class="stat-card" [nzLoading]="loading">
                <nz-table 
                    #submissionsTable 
                    [nzData]="dashboard?.submissions || []" 
                    nzSize="small" 
                    [nzShowPagination]="false"
                    [nzScroll]="{ y: '200px' }">
                    <thead>
                        <tr>
                            <th>Category</th>
                            <th nzAlign="center" nzWidth="120px">Today</th>
                            <th nzAlign="center" nzWidth="120px">7 Days</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (item of dashboard?.submissions; track $index) {
                            <tr>
                                <td>{{ item.category.category}}</td>
                                <td nzAlign="center" class="fw-bold">{{ item.submissionsCountToday }}</td>
                                <td nzAlign="center" class="fw-bold text-muted">{{ item.submissionsCount7Days }}</td>
                            </tr>
                        }
                        
                    </tbody>
                </nz-table>
            </nz-card>
        </div>

    </div> -->

</div>